module.exports = __webpack_public_path__ + "static/media/St_Pieters_en_Bloklands_gasthuis.fa170fc4.svg";